import { useState, useEffect, useRef } from "react";
import { EMOJI_CATEGORIES, EMOJI_SEARCH_INDEX } from "../../constants/emoji";

export function EmojiPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [cat, setCat] = useState(0);
  const [search, setSearch] = useState("");
  const searchRef = useRef();
  const pickerRef = useRef();

  useEffect(() => {
    if (open) setTimeout(() => searchRef.current?.focus(), 50);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  const searchResults = search.trim() ? (() => {
    const q = search.toLowerCase();
    const results = new Set();
    EMOJI_SEARCH_INDEX.forEach(([keywords, emojis]) => {
      if (keywords.some(k => k.includes(q) || q.includes(k))) emojis.forEach(e => results.add(e));
    });
    EMOJI_CATEGORIES.forEach(cat => {
      if (cat.label.toLowerCase().includes(q)) cat.emojis.forEach(e => results.add(e));
    });
    return [...results].slice(0, 36);
  })() : null;

  const displayEmojis = searchResults || EMOJI_CATEGORIES[cat].emojis;

  return (
    <div ref={pickerRef} style={{ position: "relative" }}>
      <button type="button"
        onClick={e => { e.stopPropagation(); setOpen(o => !o); setSearch(""); }}
        style={{ fontSize: "1.5rem", background: "var(--surface2)", border: "2px solid var(--border)", borderRadius: 10, width: 52, height: 44, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {value || "🎁"}
      </button>
      {open && (
        <div
          onClick={e => e.stopPropagation()}
          style={{ position: "absolute", zIndex: 200, top: "110%", left: 0, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, boxShadow: "0 8px 32px rgba(0,0,0,.18)", padding: "10px", width: 300 }}>
          <input
            ref={searchRef}
            placeholder="🔍 Search emojis…"
            value={search}
            onChange={e => { e.stopPropagation(); setSearch(e.target.value); }}
            onKeyDown={e => e.stopPropagation()}
            style={{ width: "100%", padding: "6px 10px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--surface2)", fontSize: ".85rem", marginBottom: 8, boxSizing: "border-box" }}
          />
          {!search && (
            <div style={{ display: "flex", gap: 3, flexWrap: "wrap", marginBottom: 8 }}>
              {EMOJI_CATEGORIES.map((c, i) => (
                <button key={i} type="button" onClick={e => { e.stopPropagation(); setCat(i); }}
                  style={{ fontSize: ".6rem", padding: "3px 6px", borderRadius: 8, border: "none", background: cat === i ? "var(--blue)" : "var(--surface2)", color: cat === i ? "#fff" : "var(--ink)", cursor: "pointer", fontWeight: 700 }}>
                  {c.label.split(" ")[0]}
                </button>
              ))}
            </div>
          )}
          {search && searchResults?.length === 0 && (
            <div style={{ fontSize: ".8rem", color: "var(--muted)", padding: "8px 4px" }}>No results — try a different word</div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(8,1fr)", gap: 3, maxHeight: 200, overflowY: "auto" }}>
            {displayEmojis.map((e, i) => (
              <button key={`${e}-${i}`} type="button"
                onClick={ev => { ev.stopPropagation(); onChange(e); setOpen(false); setSearch(""); }}
                style={{ fontSize: "1.2rem", background: value === e ? "var(--blue-light)" : "transparent", border: "none", borderRadius: 6, cursor: "pointer", padding: "3px", lineHeight: 1 }}>
                {e}
              </button>
            ))}
          </div>
          <div style={{ marginTop: 8, display: "flex", gap: 6, alignItems: "center", borderTop: "1px solid var(--border)", paddingTop: 8 }}>
            <span style={{ fontSize: ".72rem", color: "var(--muted)" }}>Custom:</span>
            <input style={{ flex: 1, fontSize: "1rem", padding: "3px 8px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--surface2)" }}
              placeholder="Paste emoji…" maxLength={2}
              onClick={e => e.stopPropagation()}
              onChange={e => { if (e.target.value) { onChange(e.target.value); setOpen(false); setSearch(""); } }} />
          </div>
        </div>
      )}
    </div>
  );
}
